<template>
   <v-app-bar :elevation="10" color="primary">
  <template v-slot:prepend>
    <v-btn icon>
        <v-img src="/logo.png" alt="Logo" max-width="40" width="40"/>
    </v-btn>
  </template>

  <v-app-bar-title>WIP: Kyberbezpečnost</v-app-bar-title>
  
</v-app-bar>
</template>

<script>
export default {

}
</script>